var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06722 9.48682C8.74505 9.48682 8.48389 9.74798 8.48389 10.0701V47.4035C8.48389 47.7257 8.74504 47.9868 9.06722 47.9868H48.7339C49.0561 47.9868 49.3172 47.7257 49.3172 47.4035V17.0702C49.3172 16.7479 49.0561 16.4868 48.7339 16.4868H28.9006C28.3812 16.4868 27.8887 16.2561 27.5562 15.8571L22.2476 9.48682H9.06722ZM4.98389 10.0701C4.98389 7.81499 6.81206 5.98682 9.06722 5.98682H23.0672C23.5866 5.98682 24.0791 6.21751 24.4116 6.61649L29.7202 12.9868H48.7339C50.9891 12.9868 52.8172 14.815 52.8172 17.0702V47.4035C52.8172 49.6587 50.9891 51.4868 48.7339 51.4868H9.06722C6.81207 51.4868 4.98389 49.6587 4.98389 47.4035V10.0701Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1387 32.1667C37.8217 32.8505 37.8211 33.9586 37.1373 34.6416L30.1295 41.6416C29.4462 42.3241 28.3393 42.3241 27.656 41.6416L20.6638 34.6572C19.98 33.9742 19.9794 32.8662 20.6624 32.1824C21.3455 31.4986 22.4535 31.498 23.1373 32.181L28.8927 37.93L34.6638 32.1654C35.3476 31.4823 36.4556 31.4829 37.1387 32.1667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9006 22.3202C29.8671 22.3202 30.6506 23.1037 30.6506 24.0702V40.4035C30.6506 41.37 29.8671 42.1535 28.9006 42.1535C27.9341 42.1535 27.1506 41.37 27.1506 40.4035V24.0702C27.1506 23.1037 27.9341 22.3202 28.9006 22.3202Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDownload);
export default __webpack_public_path__ + "static/media/folder-download.e141c3bb.svg";
export { ForwardRef as ReactComponent };